import React, { FC } from "react";
import cn from "classnames";
import { useTranslation } from "react-i18next";
import { getImageUrl } from "src/utils/getImageUrl";
import { ProfileInfoBlock } from "src/components/UserInfo/ProfileInfoBlock";
import { profileInfoTrns } from "src/components/UserInfo/trns";
import { IUser } from "src/@types/users";
import { Link } from "../Link";
import { TextEditorView } from "../TextEditor/TextEditorView";

interface Props {
  className?: string;
  userInfo: IUser;
}

export const UserInfo: FC<Props> = ({ className, userInfo }) => {
  const { t } = useTranslation();

  const {
    host,
    reprecention_countries: countries,
    website,
    industry,
    international,
    description,
  } = userInfo;

  return (
    <div className={cn("w-full p-3 lg:p-10 rounded-20 box-border", className)}>
      {userInfo && (
        <>
          {description && (
            <ProfileInfoBlock
              title={t(profileInfoTrns.description)}
              childrenClassName="default:my-3"
            >
              <TextEditorView>{description}</TextEditorView>
            </ProfileInfoBlock>
          )}

          <div className="flex flex-col gap-5">
            {host?.location?.country?.title && (
              <ProfileInfoBlock title={t(profileInfoTrns.location)}>
                <p>{host?.location?.country?.title}</p>
              </ProfileInfoBlock>
            )}

            <ProfileInfoBlock
              title={t(profileInfoTrns.company)}
              childrenClassName="flex flex-col gap-2"
            >
              <p>{host?.company_name}</p>
              <p>{host?.company_address}</p>
              <Link
                className="hover:text-purple-base"
                href={website}
                isExternalLink
                isOpenNewTab
              >
                <p className="break-all">{website}</p>
              </Link>
            </ProfileInfoBlock>

            <ProfileInfoBlock
              title={t(profileInfoTrns.responsiblePerson)}
              childrenClassName="flex flex-col gap-4"
            >
              <p>{host?.first_name}</p>
              <p>{host?.last_name}</p>
            </ProfileInfoBlock>

            {industry && (
              <ProfileInfoBlock
                title={t(profileInfoTrns.industry)}
                childrenClassName="flex flex-col gap-2"
              >
                <p>{industry?.title}</p>
              </ProfileInfoBlock>
            )}

            {international && (
              <ProfileInfoBlock
                title={t(profileInfoTrns.internationalMarket)}
              />
            )}

            {Boolean(countries?.length) && (
              <ProfileInfoBlock
                title={t(profileInfoTrns.representationCountries)}
                childrenClassName="flex flex-wrap gap-3"
              >
                {countries?.map(({ id, icon, slug }) => (
                  <img
                    key={id}
                    className="max-h-10"
                    src={getImageUrl(icon)}
                    alt={slug}
                    title={slug.toUpperCase()}
                  />
                ))}
              </ProfileInfoBlock>
            )}
          </div>
        </>
      )}
    </div>
  );
};
